export default function FormSubSection(props: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className={`w-full rounded-md`}>
      <strong>
        <h2 className="">{props.title}</h2>
      </strong>
      <div className={`flex flex-col items-center gap-2`}>{props.children}</div>
    </div>
  );
}
